import { useQuery } from '@tanstack/react-query';
import { DocumentCategoryApi } from 'api';

export function useGetDocumentCategories(vehicleId) {
  return useQuery({
    queryKey: ['document-categories', vehicleId],
    queryFn: () => DocumentCategoryApi.getAll(vehicleId),
  });
}
